
<div *ngIf="data?.email" class="copyHolder" [ngClass]="{'listing': location == 'listing'}" >
    <a class="email" href="mailto:{{data.email}}">{{data.email}}</a>
    <button color="primary" class="mat-icon-button" [cdkCopyToClipboard]="data.email"><mat-icon>content_copy</mat-icon></button>
</div>

<div *ngIf="onlyEmail" class="copyHolder" [ngClass]="{'listing': location == 'listing'}"  >
    <a class="email" href="mailto:{{onlyEmail}}">{{onlyEmail}}</a>
    <button color="primary" class="mat-icon-button" [cdkCopyToClipboard]="onlyEmail"><mat-icon>content_copy</mat-icon></button>
</div>




<div *ngIf="data?.phone" class="copyHolder" [ngClass]="{'listing': location == 'listing'}">
    <a class="email phone" href="tel:{{data.phone}}" >{{formatUSPhoneNumber(data.phone)}}</a>
    
    <button color="primary" class="mat-icon-button" [cdkCopyToClipboard]="data.phone"><mat-icon>content_copy</mat-icon></button>
</div>



<div *ngIf="onlyPhone" class="copyHolder" [ngClass]="{'listing': location == 'listing'}">
    <a class="email phone fff" href="tel:+{{onlyPhone}}">{{formatUSPhoneNumber(onlyPhone)}}</a>
    <button color="primary" class="mat-icon-button" [cdkCopyToClipboard]="onlyPhone"><mat-icon>content_copy</mat-icon></button>
</div>

